import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

import { Provider } from 'react-redux';
import { configureStore } from './store/configureStore';
import Root from './containers/_Root';

let store;
const rootDiv = document.getElementById('quickresponse-client');

function initApp() {
    ReactDOM.render(
        <Provider store={store}>
            <Root />
        </Provider>, rootDiv
    );
}

function init() {
    if (rootDiv) {
        axios({
            method: 'get',
            url: rootDiv.getAttribute('data-url'),
            responseType: 'json',
        })
        .then((response) => {
            store = configureStore(response.data);
            initApp();
        })
        .catch((response) => {
            console.log(response);
        });
    }
}

export { init };



// WEBPACK FOOTER //
// ./src/_app/quick_response/clientside.js